import { Injectable } from '@angular/core';
import { Pos, PosDetailWithOrders, TableTransfer } from '../../../../core/models/pos.model';
import { Observable } from 'rxjs';
import { PosServiceAdapter } from '../../../../core/integrations/nosERP/services/pos.service.adapter';

@Injectable({
  providedIn: 'root'
})
export class PosService {
  constructor(private posServiceAdapter: PosServiceAdapter) {}

  getPosList(): Observable<Pos[]> {
    return this.posServiceAdapter.getPosList();
  }

  // this function bypasses the need of requesting the current saleSession returning the orders immediately
  getPosCurrentSaleSessionOrdersWithDetails(posId: string): Observable<PosDetailWithOrders> {
    return this.posServiceAdapter.getPosCurrentSaleSessionOrdersWithDetails(posId);
  }

  deletePosOrder(posId: string, orderId: string): Observable<any> {
    return this.posServiceAdapter.deletePosOrder(posId, orderId);
  }

  createPosOrder(posId: string, accountName: string, geral?: boolean): Observable<any> {
    return this.posServiceAdapter.createPosOrder(posId, accountName);
  }

  updatePosOrder(posId: string, orderId: string, orderName: string) {
    return this.posServiceAdapter.updatePosOrder(posId, orderId, orderName);
  }

  addTable(param: { nome: string; id_mesa?: string }) {
    return this.posServiceAdapter.addTable(param);
  }

  transferTable(param: TableTransfer) {
    return this.posServiceAdapter.transferTable(param);
  }

  addRequest(param: any) {
    return this.posServiceAdapter.addRequest(param);
  }

  openTable(param: any) {
    return this.posServiceAdapter.openTable(param);
  }

  doPayment(param: any) {
    return this.posServiceAdapter.doPayment(param);
  }

  downloadInvoice(receiptId: string | number) {
    return this.posServiceAdapter.downloadInvoice(receiptId);
  }

  refreshPosDetails(posId: string) {
    return this.posServiceAdapter.refreshPosDetails(posId);
  }

  createDefaultOrderForPos(id: string) {
    return this.posServiceAdapter.createDefaultOrderForPos(id);
  }
}
